<hsg-modal>
  <span class="title">פנייה לשירות לקוחות</span>
  <div [gaManager]="{type:'impression',category:this.gaCategory,action:'Customer Service ticket - details presented',label:'User Initiated = '+(data.CustomerServiceReason==23)+' - '+data.CustomerServiceReason}" class="body" ngForm #customerServiceForm="ngForm" (ngSubmit)="submit(customerServiceForm)" (keyup.enter)="customerServiceForm.onSubmit()">
    <p>
      שדות בטופס המסומנים בכוכבית הינם שדות חובה
     <span class="asterix">*</span>
      </p>    
        
    <div class="h-gr h-gr--nowrap">

        <div class="c-column-logo">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 128 128">
              <path d="M61.4,101.9v12.5h-4v-12.5c0-4.8-10.3-8.4-16.9-8.4s-16.9,3.6-16.9,8.4v12.5h-4v-12.5
                c0-8.6,13.9-12.4,20.9-12.4S61.4,93.2,61.4,101.9z"/>
              <path d="M28,73.1v2.1c0,6.8,5.6,12.3,12.5,12.3S53,82,53,75.2v-2.1c0-6.8-5.6-12.3-12.5-12.3S28,66.4,28,73.1z
                 M49,73.1v2.1c0,4.6-3.8,8.3-8.5,8.3S32,79.8,32,75.2v-2.1c0-4.6,3.8-8.3,8.5-8.3S49,68.6,49,73.1z"/>
              <path d="M97.4,58.7h4v6.2c0,4.5-3.7,8.2-8.3,8.2H80.7L66.2,88.6c-0.8,0.6-1.7,0.9-2.6,0.9c-0.6,0-1.2-0.1-1.8-0.4
                c-1.4-0.7-2.2-2-2.2-3.6V73.1h-4.3v-4h8.3v16.4c0,0,0.1,0,0.1,0L79,69.1h14.1c2.4,0,4.3-1.9,4.3-4.2V58.7z M25.8,73.1v-4h-4.2
                c-2.4,0-4.3-1.9-4.3-4.2V25.7c0-2.3,1.9-4.2,4.3-4.2h71.6c2.4,0,4.3,1.9,4.3,4.2v2.1h4v-2.1c0-4.5-3.7-8.2-8.3-8.2H21.5
                c-4.6,0-8.3,3.7-8.3,8.2v39.2c0,4.5,3.7,8.2,8.3,8.2H25.8z M72.1,29.9H27.9v4h44.2V29.9z M72.1,38.1H27.9v4h44.2V38.1z M57.3,46.4
                H27.9v4h29.5V46.4z"/>
              <path d="M117.8,27.5l-3.2-3.1c-1.7-1.6-4.1-1.9-5.5-0.5c0,0,0,0,0,0L80.4,52.1c-0.2,0.2-0.4,0.5-0.5,0.9l-2.4,8.7
                c-0.2,0.7,0,1.4,0.5,2c0.4,0.4,0.9,0.6,1.4,0.6c0.2,0,0.4,0,0.5-0.1l8.8-2.4c0.3-0.1,0.6-0.3,0.9-0.5L118.3,33c0.6-0.6,1-1.4,1-2.4
                C119.2,29.5,118.7,28.4,117.8,27.5z M87.1,58l-4.9,1.3l1.3-4.7l23.5-23.1l3.5,3.5L87.1,58z M113.5,32.1l-3.5-3.5l1.6-1.6
                c0.1,0,0.1,0.1,0.2,0.2l3.2,3.1c0.1,0.1,0.1,0.1,0.1,0.1L113.5,32.1z"/>
            </svg>
            
        </div>

      <div class="h-cl">

        <p>
באפשרותך לשלוח אלינו את שמך ונציג התמיכה יחזור אליך למספר הטלפון שבאמצעותו ניסית להתחבר. מוקד התמיכה פועל בין השעות 8:00 ועד 16:00, בימים א' עד ה'.
        </p>
        <div class="h-gr">
          <div class="h-cl">
            <hsg-field>
              <input type="text" class="h-field__element" name="firstName" id="firstName" hsgInput required maxlength="50" ngModel #firstname="ngModel" pattern="^[A-Za-zא-ת- ]+$" aria-invalid="false">
              <label hsgLabel>שם פרטי</label>
              <div hsgError *ngIf="firstname.invalid && customerServiceForm.submitted">
                <div hsgError *ngIf="firstname?.errors?.required">
                  לא הוזן שם פרטי
                </div>
                <div hsgError *ngIf="firstname?.errors?.pattern">
                  אחד התווים לא חוקי
                </div>
              </div>
            </hsg-field>
          </div>
          <div class="h-cl">
              <hsg-field>
                  <input type="text" class="h-field__element" name="lastName" id="lastName" hsgInput required maxlength="50" ngModel #lastname="ngModel" pattern="^[A-Za-zא-ת- ]+$" aria-invalid="false">
                  <label hsgLabel>שם משפחה</label>
                  <div hsgError *ngIf="lastname.invalid && customerServiceForm.submitted">
                    <div hsgError *ngIf="lastname?.errors?.required">
                      לא הוזן שם משפחה
                    </div>
                    <div hsgError *ngIf="lastname?.errors?.pattern">
                      אחד התווים לא חוקי
                    </div>
                  </div>
                </hsg-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button hsg-button kind="primary" (click)="customerServiceForm.onSubmit()" [disabled]="pending">המשך
      <hsg-spinner *ngIf="pending" class="u-mr-s"></hsg-spinner>
    </button>
  </div>
</hsg-modal>